import React from "react";
import { mergeStyles } from "office-ui-fabric-react";
import Column from "./Column";
import i18next from "i18next";
import { MethodsOfPayment } from "../../orders/models/MethodsOfPayment.enum";
import { translateOrderTypeName } from "../../common/enums/orderTypes.enum";

const containerS = mergeStyles({
  margin: "0",
  padding: "30px",
});

const header = mergeStyles({
  fontWeight: "700",
});

const orderNubmer = mergeStyles({
  paddingRight: 15,
  fontWeight: "700",
});

const numberHeader = mergeStyles({
  display: "flex",
});

const logo = mergeStyles({
  height: 100,
});

const signContainer = mergeStyles({
   
})

class OrderPrint extends React.Component<any> {
  render() {
    return (
      <>
        {this.props.data && (
          <div className={containerS}>
            <img src="/logo2.jpg" alt="" className={logo} />
            <h2 className={numberHeader}>
              <div className={orderNubmer}>
                <p>{i18next.t("printing.orderNumber", { ns: "admin" })}</p>
              </div>
              <div>
                <p>{this.props.data.orderInfo.number}</p>
              </div>
            </h2>
            <h3 className={header}>{i18next.t("printing.orderHistory", { ns: "admin" })}</h3>
            <Column
              name={i18next.t("printing.acceptedDate", { ns: "admin" })}
              value={this.props.data.orderInfo.acceptedDate
                .split("T")
                .splice(0, 1)}
            />
            <Column
              name={i18next.t("printing.plannedDate", { ns: "admin" })}
              value={this.props.data.orderInfo.acceptedDate
                .split("T")
                .splice(0, 1)}
            />

            <h3 className={header}>{i18next.t("printing.orderData", { ns: "admin" })}</h3>
            <Column
              name={i18next.t("printing.clientName", { ns: "admin" })}
              value={this.props.data.orderInfo.company}
            />
            <Column
              name={i18next.t("printing.phone", { ns: "admin" })}
              value={
                this.props.data.orderInfo.receptionPlacePhone
                  ? this.props.data.orderInfo.receptionPlacePhone
                  : ""
              }
            />
            <Column
              name={i18next.t("printing.receptionAddress", { ns: "admin" })}
              value={this.props.data.orderInfo.receptionPlace}
            />
            <Column
              name={i18next.t("printing.vehicle", { ns: "admin" })}
              value={this.props.data.orderInfo.vehicle}
            />
            <Column
              name={i18next.t("printing.orderType", { ns: "admin" })}
              value={translateOrderTypeName(this.props.data.orderInfo.type)}
            />
            <Column name={i18next.t("printing.quantity", { ns: "admin" })} value={this.props.data.orderInfo.quantity} />
            <Column
              name={i18next.t("printing.paymentMethod", { ns: "admin" })}
              value={this.props.data.paymentType === MethodsOfPayment.CASH ? i18next.t("printing.cash", { ns: "admin" }) : i18next.t("printing.transfer", { ns: "admin" })}
            />
            <Column name={i18next.t("printing.grossAmount", { ns: "admin" }) as string} value={this.props.data.totalValue} />
            <div className={signContainer}>
              <div>
                <p>................................</p>
              </div>
              <div>
                <p>{i18next.t("printing.signature", { ns: "admin" })}</p>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default OrderPrint;
